const carRental = {
  carRental: "Pagrenta ng Kotse", // translated 
  carRentals: "Mga Paupahang Kotse", // translated 
  pickUpPoint: "Punto ng Pagsundo", // translated 
  dropOffPoint: "Lugar ng Pagbaba", // translated 
  pleaseSelectAPickUpPoint: "Pumili ng Pick-up Point", // translated 
  pickUpDate: "Petsa ng Pagkuha", // translated 
  dropOffDate: "Petsa ng Paghahatid", // translated 
  pickUp: "Pagkuha", // translated 
  dropOff: "Pagbaba", // translated 
  edit: "I-edit", // translated 
  fuelPolicy: "Patakaran sa Panggatong", // translated 
  pickUpLocation: "Lokasyon ng Pagsundo", // translated 
  mileage: "Mileage", // translated 
  transmission: "Paghawa", // translated 
  airCondition: "Kondisyon ng Hangin", // translated 
  minimumAge: "Minimum na Edad", // translated 
  maximumAge: "Pinakamataas na Edad", // translated 
  providerAddress: "Address ng Tagapagbigay ng Serbisyo", // translated 
  providerPhone: "Telepono ng Tagapagbigay ng Serbisyo", // translated 
  driverInfo: "Impormasyon sa Pagmamaneho", // translated 
  driversInfo: "Impormasyon ng Driver", // translated 
  differentDropOff: "Pagbaba sa ibang lokasyon", // translated 
  maxPassengers: "Pinakamataas na Pasahero", // translated 
  budget: "Badyet", // translated 
  provider: "Tagapagbigay ng serbisyo", // translated 
  carModel: "Modelo ng Kotse", // translated 
  numOfDoors: "Bilang ng mga Pinto", // translated 
  fuelType: "Uri ng Panggatong", // translated 
  driverAge: "Edad ng Pagmamaneho", // translated 
  enterValidDriversAge: "Mangyaring maglagay ng wastong Edad ng Pagmamaneho.", // translated 
  workingHours: "Mga Oras ng Paggawa", // translated 
  driverNationality: "Nasyonalidad ng Nagmamaneho", // translated 
  nationalityIsRequired: "Kinakailangan ang nasyonalidad", // translated 
  carRentalRate: "Halaga ng Pagrenta ng Kotse", // translated 
  dueNow: "Bayad Ngayon", // translated 
  duePickUp: "Bayad sa Pagkuha", // translated 
  toViewOfferPDF:
    "Para matingnan ang isang PDF na dokumento na naglalaman ng lahat ng mga tuntunin sa pagrenta ng alok na ito, mangyaring", // translated 
  toViewTermsAndCondPDF:
    "Para makita ang naaangkop na Mga Tuntunin at Kundisyon ng CARNECT, mangyaring", // translated 
  carRentalsNotFound:
    "Wala kaming makitang resulta ng Pagrenta ng Kotse. Humihingi kami ng paumanhin sa abala.", // translated 
};


export default carRental;
